import { PaymentAllocationMethod } from '@rematter/frontend-lib-api-client';
import { Button, Row } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

interface AllocationBannerProps {
  variant: 'bill' | 'invoice';
  selectedAllocationMethod: PaymentAllocationMethod | null;
  onKeepCurrent: () => void;
  onApply: () => void;
}

//
// ⚛️ ⚛️ ⚛️ ALLOCATION BANNER ⚛️ ⚛️ ⚛️
//
export const AllocationBanner = ({
  variant,
  selectedAllocationMethod,
  onKeepCurrent,
  onApply,
}: AllocationBannerProps) => {
  // Translations
  const t = useTranslations();

  const translations =
    variant === 'bill'
      ? t.bills.paymentDrawer.allocationBanner
      : t.invoices.paymentDrawer.allocationBanner;

  return (
    <Row xBetween className="@AllocationBanner rounded bg-warning/10 px-3 py-2">
      <p className="text-sm">
        {selectedAllocationMethod &&
          translations.message(selectedAllocationMethod)}
      </p>
      <Row gap2>
        <Button variant="outline" onPress={onKeepCurrent}>
          {translations.keepCurrent}
        </Button>
        <Button variant="solid" color="warning" onPress={onApply}>
          {translations.apply}
        </Button>
      </Row>
    </Row>
  );
};
